import { Link } from 'react-router-dom';

import './FormIndex.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Button, Col } from 'react-bootstrap';
import TrimmedParagraph from './TrimmedParagraph';

import { useEffect } from 'react';
import { useAuth } from '../../../context/authContext';

const FormIndex = () => {
  const text1 = 'JHA-Job Hazard Analysis';
  const text2 =
    'Employees use this form for requesting reimbursement for expenses NOT related to travel.';
  const text3 = `Employees are required to submit a Trip Report of all non-local travel.`;
  const text4 = `The Nomination for Award form is designed to recognize and celebrate employees'
outstanding contributions and achievements. It allows managers to formally nominate individuals for
various organizational awards. The form captures the nominee's details, the type of award, and a
justification for the nomination.`;
  const text5 = `The Requisition Request form is used by department heads or managers to formally
request the hiring of new personnel or to refill a vacant position within the organization.`;
  const text6 = `The Application for Educational Assistance eForm will be used by employees to
request financial support or reimbursement for educational courses or programs that enhance their skills
and contribute to their professional development.`;
  const text7 = `The "Application for Training" eForm is designed for employees seeking company
support for short-term training programs that enhance their professional skills or qualifications but are
not part of a degree-granting process. his eForm collects essential information such as the training
program's name, the provider, the duration, the expected outcomes, and the associated costs and any
Certificates or Certification achieved. It also captures the rationale for how the training aligns with the
employee’s current role or career progression within the company.`;
  const text8 = `The Skill eForm will be used by employees to
update there skills.`;
  const text9 = `Initiate the process of
extending a job offer to a candidate. The form captures key details such as the candidate's information,
the position being offered and compensation.`;
  const text10 = `The Mission Critical Flex Time (MCFT) eForm is designed for managers to submit on
behalf of employees who must work additional hours due to the critical demands of a project. Flex or
comp time is only granted in special cases and must be used within 90 days following the end of the
MCFT period, ensuring that any extra time worked is appropriately balanced within a defined timeframe.`;
  const text11 = `The Extended Work Week (EWW) eForm is specifically crafted for Managers of
contract employees who in specific cases need to extend employees working hours due to project
demands. This form serves as a formal request mechanism, abling managers to outline the specifics of
required extended hours and the justifications based on current project needs.`;
  const text12 = `The Subcontractor Health and Safety Report is designed to capture critical
information regarding subcontractor activities, workforce, and safety incidents, both on-site and off-site.
This report ensures that all subcontractors are compliant with the organization's health and safety
standards, tracks incidents or hazards, and maintains documentation of hours worked and incident
details.`;

  const text13 = `This eForm is used by managers to request facilities services for new hires,
contractors, and visitors who will be either temporarily or permanently assigned to the
aerospace facility.`;
  const { user } = useAuth();

  useEffect(() => {}, []);
  return (
    <>
      <Card>
        <div className="noWrap">
          {user?.allowedModules?.map((module, index) => {
            if (module.value.toLowerCase() === 'jha-form') {
              return (
                <Col md={3} className="formCard" key={`jha-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">JHA - Job Hazard Analysis</p>
                  <TrimmedParagraph text={text1} wordLimit={10} />
                  <Link to={'/jha-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'voucher-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`voucher-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">04ACCT - Voucher</p>
                  <TrimmedParagraph text={text2} wordLimit={10} />
                  <Link to={'/voucher-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'tripreport-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`tripreport-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">25ACCT - Trip Report</p>
                  <TrimmedParagraph text={text3} wordLimit={10} />
                  <Link to={'/tripreport-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'award-form') {
              return (
                <Col md={3} className="formCard" key={`award-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">13HRM - Nomination for Award</p>
                  <TrimmedParagraph text={text4} wordLimit={10} />
                  <Link to={'/award-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'coi-form') {
              return (
                <Col md={3} className="formCard" key={`coi-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">55HRM - Conflict of Interest</p>
                  <TrimmedParagraph text={text5} wordLimit={10} />
                  <Link to={'/coi-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'requisition-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`requisition-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">61HRM - Requisition Request</p>
                  <TrimmedParagraph text={text5} wordLimit={10} />
                  <Link to={'/requisition-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'aea-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`requisition-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">12HRM - Application for Educational Assistance</p>
                  <TrimmedParagraph text={text6} wordLimit={10} />
                  <Link to={'/aea-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'training-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`training-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">51HRM - Application for Training</p>
                  <TrimmedParagraph text={text7} wordLimit={10} />
                  <Link to={'/training-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'skills-form') {
              return (
                <Col
                  md={3}
                  className="formCard"
                  key={`skills-'${index}`}
                  style={{ width: '17rem' }}
                >
                  <p className="text-title">Skill Form</p>
                  <TrimmedParagraph text={text8} wordLimit={10} />
                  <Link to={'/skills-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'offer-form') {
              return (
                <Col md={3} className="formCard" key={`offer-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">62HRM - Offer Request</p>
                  <TrimmedParagraph text={text9} wordLimit={10} />
                  <Link to={'/offer-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'mcft-form') {
              return (
                <Col md={3} className="formCard" key={`mcft-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">34CNT - MCFT Form</p>
                  <TrimmedParagraph text={text10} wordLimit={10} />
                  <Link to={'/mcft-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'eww-form') {
              return (
                <Col md={3} className="formCard" key={`eww-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">09CNT - Extended Work Week Form</p>
                  <TrimmedParagraph text={text11} wordLimit={10} />
                  <Link to={'/eww-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'shs-form') {
              return (
                <Col md={3} className="formCard" key={`eww-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">04CNT - Subcontractor Health and Safety Form</p>
                  <TrimmedParagraph text={text12} wordLimit={10} />
                  <Link to={'/shs-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
            if (module.value.toLowerCase() === 'fsr-form') {
              return (
                <Col md={3} className="formCard" key={`eww-'${index}`} style={{ width: '17rem' }}>
                  <p className="text-title">03FAC - Facilities Services Request Form</p>
                  <TrimmedParagraph text={text13} wordLimit={10} />
                  <Link to={'/fsr-form'} rel="noopener noreferrer">
                    <Button className="form-button">Open</Button>
                  </Link>
                </Col>
              );
            }
          })}
        </div>
      </Card>
    </>
  );
};

export default FormIndex;
